var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPower = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-power")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    d: "M2.217 17.527l-0.087 0.116c-0.553 0.83 0.034 1.983 1.070 1.983l11.35-0-1.242 9.939c-0.159 1.268 1.435 1.96 2.253 0.978l14.309-17.183c0.553-0.83-0.034-1.983-1.070-1.983l-11.35-0.001 1.242-9.938c0.159-1.268-1.435-1.96-2.253-0.978l-14.222 17.067zM15.61 5.454l-0.88 7.045-0.010 0.151c-0.005 0.7 0.562 1.287 1.28 1.287l10.066-0.001-9.677 11.613 0.881-7.045 0.010-0.151c0.005-0.7-0.562-1.287-1.28-1.287l-10.067-0 9.677-11.612z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPower, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-power.ff35243e.svg";
export { ForwardRef as ReactComponent };